import { createFileRoute, Link } from "@tanstack/react-router"
import { ClipboardList } from "lucide-react"
import { useTranslation } from "react-i18next"
import { GoalsChecklist } from "@/components/forms/goals-checklist"
import { ValuesReflectionForm } from "@/components/forms/values-reflection-form"
import { Page } from "@/components/page"
import { PageLoader } from "@/components/page-loader"
import { Button } from "@/components/ui/button"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { Typography } from "@/components/ui/typography"
import { trpc } from "@/lib/trpc"

export const Route = createFileRoute("/_authed/_individual/personal/goals")({
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  const { data: user, isLoading: userLoading } = trpc.users.me.useQuery()
  const estateId = user?.estateId ?? ""

  if (userLoading) {
    return (
      <Page
        headerSlot={
          <Typography as="h1" size="2xl">
            {t("common.loading")}
          </Typography>
        }
      >
        <PageLoader />
      </Page>
    )
  }

  return (
    <Page
      headerSlot={
        <div className="flex w-full items-center justify-between gap-4">
          <Typography as="h1" size="2xl">
            {t("pages.goals.title")}
          </Typography>

          <Button className="hidden md:flex" variant="outline" asChild>
            <Link to="/personal/guided-forms">
              <ClipboardList className="mr-1 size-4" aria-hidden="true" />
              Go to Guided Form
            </Link>
          </Button>
        </div>
      }
    >
      <Tabs defaultValue="goals" className="w-full">
        <TabsList>
          <TabsTrigger value="goals">{t("pages.goals.tabs.estatePlanning")}</TabsTrigger>
          <TabsTrigger value="values">{t("pages.goals.tabs.valuesLegacy")}</TabsTrigger>
        </TabsList>

        <TabsContent value="goals" className="space-y-6">
          <GoalsChecklist estateId={estateId} />
        </TabsContent>

        <TabsContent value="values" className="space-y-6">
          <ValuesReflectionForm estateId={estateId} />
        </TabsContent>
      </Tabs>
    </Page>
  )
}
